import { useI18n } from "@wato/i18n/react";
import type { PresenceStatus } from "../../../api/routing-types";

const COLOR: Record<PresenceStatus, string> = {
  online: "bg-success-icon",
  busy: "bg-danger-icon",
  mobile: "bg-info-icon",
  away: "bg-warning-icon",
  offline: "bg-line-strong",
};

/** WP-503: green / yellow / gray dot; the tooltip shows last-active time when not online. */
export function PresenceIndicator({
  status,
  lastActiveAt,
}: {
  readonly status: PresenceStatus;
  readonly lastActiveAt?: string | null;
}) {
  const { t } = useI18n();
  const label = t(`routing.presence.${status}`);
  const title =
    status !== "online" && lastActiveAt
      ? `${label} · ${t("routing.presence.lastActive", { time: new Date(lastActiveAt).toLocaleString() })}`
      : label;
  return (
    <span
      role="img"
      aria-label={label}
      title={title}
      data-testid={`presence-${status}`}
      className={`inline-block h-2.5 w-2.5 rounded-full ${COLOR[status]}`}
    />
  );
}
